import { jwtDecode } from 'jwt-decode';

export const safeJWTDecode = (token: string) => {
  try {
    return jwtDecode<{ sub: string }>(token);
  } catch (error) {
    console.log(`failed to decode token: ${error}, token: ${token}`);
    return { sub: '' };
  }
};
